export const environment = {
  production: false,
  sentryDsn: 'https://f3981f91164d82ef387130a3fe43c310@o4506308503273472.ingest.sentry.io/4506670595571712',
  version: '9.4.0',
  hostName: 'https://api.calenso.io/api/v1/',
  deployUrl: 'https://l.calenso.io',
  appName: 'Calenso',
  faviconPath: 'assets/brands/calenso/favicon.ico',
};
